import React, { useState, useEffect } from 'react'
import Joyride from 'react-joyride';
import { useTranslation } from 'react-i18next';
import { optionStyles, locale } from '../customize';
import { useTutorialContext } from '../../GuideTour/TutorialProvider';

export default function StartGuide({ onStart, onCompleteIntro }) {
    const [loader, setLoader] = useState(false)
    const [run, setRun] = useState(true)
    const { t } = useTranslation()
    const { setTutorialBox } = useTutorialContext()

    useEffect(() => {
       setTimeout(() => setLoader(true), 800)
    }, [])

    const step = [
        {
            target: '#start-button',
            content: t('features.GuideTour.IntroduceGuide.start'),
            placement: 'right',
            disableBeacon: true,
        },
        {
            target: '#start-button',
            content: t('features.GuideTour.IntroduceGuide.start'),
            placement: 'right',
            disableBeacon: true,
        },
    ];

    const handleCallback = data => {
        const { action, index, lifecycle, type } = data;
        if (action === 'skip') {
            setRun(false)
            setTutorialBox({ onOpen: false, onStart: false, onCompleteIntro: false })

        }
        if (type === 'step:after' && index === 0) {
            if (action === 'next') {
                setRun(false)
                setTutorialBox({ onOpen: true, onStart: true, onCompleteIntro: false })
            }
        }
    };

    return (
        <div>
            {loader &&
                <Joyride
                    steps={step}
                    run={run}
                    stepIndex={0}
                    callback={handleCallback}
                    styles={optionStyles}
                    locale={locale(t)}
                    continuous
                    showSkipButton
                    scrollToFirstStep
                    hideCloseButton
                    disableOverlayClose />
            }
        </div>
    )
}
